import React from 'react';
import useCalculateurBatico from './useCalculateurBatico';
import CalculateurBaticoView from './CalculateurBaticoView';

export default function CalculateurBATICO() {
  const ctx = useCalculateurBatico();
  return <CalculateurBaticoView ctx={ctx} />;
}
